import React from 'react';

export type Config = {
	AUTH_CLIENT_ID: string;
	AUTH_AUTHORITY: string;
	AUTH_AUTHORITY_KNOWNS: string;
	AUTH_REDIRECT_URI: string;
	AUTH_SCOPE: string;
	API_URL: string;
	RUNTIME_URL: string; // app-runtime URL for iframe preview
	RUNTIME_ORIGIN?: string; // postMessage origin for iframe security (defaults to '*')
	RUNTIME_API_URL?: string;
	RUNTIME_EMBED_SCRIPT_URL?: string;
};

const ConfigContext = React.createContext<Config>(undefined!);

export default ConfigContext;
